import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import {cryptoJs} from '@deanwu/vue-component-library'
import dictList from './dict.js'

const dictData = {};
for (let key in dictList) {
	dictData[key] = stateSerialize(dictList[key]);
}
function stateSerialize(data) {
	let json = {};
	data.forEach(item => {
		if (typeof item.value == 'object') {
			item.value.forEach(i => {
				json[i] = item;
			});
		} else {
			json[item.value] = item;
		}
	});
	
	return json;
}

Vue.use(Vuex);

const app = new Vue();
const Store = new Vuex.Store({
	state: {
		...dictList,
		dictData: {
			...dictData
		},
		asyncDictList: {},
		asyncDictData: {},
		session: '',
		saasInfo: null,
		userInfo: null,
		authList: [],
		navList: [],
		toolList: [],
		formulaDict: null,
		customField: null,
		systemConfig: null,
		publicConfig: null
	},

	getters: {
		initialized(state) {
			return state.systemConfig && state.formulaDict && state.customField;
		},

		customFieldMenu(state) {
			let nav = state.navList.find(item => item.menu_unique_key == 'g_organization');
			let field = nav.child_menu_list.find(item => item.menu_unique_key == 'p_custom');
			let menu = field ? field.child_menu_list.find(item => item.menu_unique_key == 'm_custom_field') : undefined;
			return menu ? menu.child_menu_list : [];
		},

		allAuthKey(state) {
			return state.authList.map(item => item.key);
		},

		freeAuthKey(state) {
			return state.authList.filter(item => !item.vip).map(item => item.key);
		},

		freeEdition(state) {
			return state.saasInfo.is_vip == 2;
		}
	},

	mutations: {
		updateAsyncDict(state, data) {
			Vue.set(state.asyncDictList, data.dict, data.data);
			Vue.set(state.asyncDictData, data.dict, stateSerialize(data.data));
		},
		
		setSystemConfig(state, data) {
			if (state.session) {
				state.systemConfig = data;
			}
			state.publicConfig = data;
		},

		setFormulaDict(state, data) {
			state.formulaDict = data;
		},

		setCustomField(state, data) {
			state.customField = data;
		},
		
		setSession(state, data) {
			state.session = data;
			if (!data) {
				state.systemConfig = null;
			}
		},
		
		// 设置企业信息
		setSaasInfo(state, data) {
			state.saasInfo = data;
		},
		
		// 设置用户信息
		setUserInfo(state, data) {
			delete data.session;
			state.userInfo = data;
		},
		
		// 设置权限列表
		setAuth(state, data) {
			state.authList = data;
		},
		
		// 设置导航菜单
		setNav(state, data) {
			data.forEach(nav => {
				nav.group = ['g_report', 'g_basic', 'g_organization', 'g_tool'].includes(nav.menu_unique_key);
				if (nav.menu_unique_key == 'g_tool') {
					try {
						state.toolList = nav.child_menu_list[0].child_menu_list;
					} catch(e) {}
					nav.child_menu_list = [];
				} else {
					nav.child_menu_list.forEach(menu => {
						menu.child_menu_list.forEach(item => {
							item.window = ['m_schedule_calendar'].includes(item.menu_unique_key);
						});
					});
				}
			});
			data.unshift({
				id: 1,
				menu_name: '工作台',
				menu_unique_key: 'home'
			});
			state.navList = data;
		}
	},

	actions: {
		updateSystemConfig(store) {
			app.request({
				url: '/sys/config',
				success: data => {
					store.commit('setSystemConfig', data);
				}
			})
		},

		updateFieldConfig(store, callback) {
			Promise.all([
				app.request({
					url: '/sys_field/map'
				}),

				app.request({
					url: '/sys_field/custom/map'
				})
			]).then(([{data: dict}, {data: custom}]) => {
				store.commit('setFormulaDict', dict);
				store.commit('setCustomField', custom);
				callback && callback();
			});
		},

		updateLoginInfo(store) {
			app.request({
				url: '/sys_user/get_login_info',
				success: data => {
					store.dispatch('setLoginInfo', data);
				},
				fail: (code, data, msg) => {
					if (code == 9200) {
						app.$confirm({
							message: msg,
							buttonName: '我知道了',
							cancelButton: false,
							resolve: () => {
								store.commit('setSession', '');
								$app.navigateTo('/login');
							}
						})
						return false;
					}
				}
			})
		},

		setLoginInfo(store, data) {
			store.commit('setSession', data.user_info.session);
			store.commit('setSaasInfo', data.saas_info);
			store.commit('setUserInfo', data.user_info);
			store.commit('setAuth', data.user_menu_key_list.map(item => {
				return {
					key: item.menu_unique_key,
					vip: item.is_vip == 1
				}
			}));
			store.dispatch('updateExtendNav', data.user_menu_list || []);
		},

		async updateExtendNav(store, navList) {
			let nav = navList.find(item => item.menu_unique_key == 'g_report');
			let kanban = nav ? nav.child_menu_list.find(item => item.menu_unique_key == 'p_workshop') : undefined;
			if (kanban) {
				let index = kanban.child_menu_list.findIndex(item => item.menu_unique_key == 'm_digital_data');
				if (index > -1) {
					let {data} = await app.request({
						url: '/digital/menu'
					});

					kanban.child_menu_list.splice(...[index, 1].concat(data.map(item => {
						return {
							type: 'kanban',
							id: item.digital_id,
							menu_name: item.menu_name,
							menu_unique_key: 'm_digital_data'
						}
					})));

					if (!kanban.child_menu_list.length) {
						nav.child_menu_list.splice(nav.child_menu_list.findIndex(item => item == kanban), 1);
					}
				}
			}
			store.commit('setNav', navList);
		},
		
		getAsyncDict(store, dict) {
			store.commit('updateAsyncDict', {
				dict: dict,
				data: []
			});
			
			app.request({
				url: '/basic/dic/info_list',
				data: {
					dic_type_code: dict
				},
				success: data => {
					store.commit('updateAsyncDict', {
						dict: dict,
						data: Array.from(data, item => {
							return {
								name: item.name,
								value: item.code,
								data: item
							}
						})
					});
				}
			})
		}
	},

	plugins: [createPersistedState({
		key: 'session',
		paths: ['session', 'authList'],
		storage: {
			getItem(key) {
				try {
					return JSON.parse(cryptoJs.AES.decrypt(localStorage.getItem(key), 'session').toString(cryptoJs.enc.Utf8));
				} catch(e) {
					return undefined;
				}
			},
			
			setItem(key, val) {
				localStorage.setItem(key, cryptoJs.AES.encrypt(JSON.stringify(val), 'session').toString());
			},
			
			removeItem(key) {
				localStorage.removeItem(key);
			}
		}
	})]
});
export default Store

const asyncMapState = function(data) {
	const res = {};
	data.forEach(dict => {
		res[dict] = {
			get() {
				if (!Store.state.asyncDictList[dict]) {
					Store.dispatch('getAsyncDict', dict);
				}
				
				return Store.state.asyncDictList[dict];
			},
			set() {}
		}
	});
	return res;
}
export {
	asyncMapState
}
